import { useStyle } from "../style";
import { SvgIcon } from "@mui/material";
import userIconImg from "@static/img/dashboard/user.svg";

export const UserIcon = () => {
    const { classes } = useStyle({});

    return <SvgIcon className={classes.iconBox} component={userIconImg} viewBox="0 0 30 30" />;
};
